module.exports = __webpack_public_path__ + "static/media/14_avatar.13fb0089.png";